module.exports = __webpack_public_path__ + "img/ic_200_contract.2d3a2880.png";